<template>
  <v-dialog v-model="open" persistent max-width="600px">
    <material-card color="primary" :title="title">
      <v-form ref="form" v-model="validForm">
        <v-container grid-list-md>
          <v-layout wrap>


            <v-flex xs12 sm6 md6>
              <v-select
                clearable
                md4
                v-model="item.protocol_id"
                :items="protocols"
                label="Protocol"
                :rules="validators.protocol_site.protocol"
                item-value="id"
                item-text="name"
                :disabled="!isNew"
                @change="checkExists()"
              ></v-select>
            </v-flex>

             <v-flex xs12 sm6 md6>
              <v-text-field
                label="Code"
                v-model="item.code"
                :rules="validators.protocol_site.code"
                :readonly="!$can('upsert', 'protocol_site')"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 md12>
               <v-autocomplete
                md4
                clearable
                :search-input.sync="siteSearchString"
                v-model="item.site_id"
                :items="sites"
                color="green"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Site Name"
                placeholder="Choose from Sites..."
                prepend-icon="mdi-database-search"
                :loading="loadingSites"
                @input="selectedSite();checkExists();"
                :disabled="!isNew"
                :rules="validators.protocol_site.site"
                :readonly="!$can('upsert', 'protocol_site')"
              >

                <template slot="item" slot-scope="{ item }" >
                  <v-list-tile-content>
                      <v-list-tile-title>{{item && item.name}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{item && item.country}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            
          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >

        <v-btn
          v-if="$can('upsert', 'protocol_site')"
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!checkSave() || !validForm"
          @click="save()"
          >Save</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { upsert, getDetail } from "@/api/protocol_site";
import { getList as getSites } from "@/api/site";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  data() {
    return {
      validForm: true,
      validators,
      loadingSites: false,
      siteSearchString: '',
      sites: [{}],
      errors: false
    };
  },
  mounted() {
    if (!this.isNew) {
      this.sites.push(this.item.site);
    }
  },
  watch: {
    open() {
      if (this.isNew) {
        this.$refs.form.reset();
      } else {
         this.sites.push(this.item.site);
      }
    },
    siteSearchString(val, oldVal) {
        if (!val) {
          this.sites = [{}];
          return;
        }
        this.loadingSites = true
        getSites({'name': val + '%'}, {rowsPerPage: null}).then((data) => {
          this.sites = data.data;
          this.loadingSites = false;
        })
    },
  },
  computed: {
    open() {
      return this.$store.getters.protocolSiteDialog;
    },
    item: {
      get() {
        return this.$store.getters.protocolSiteItem;
      },
      set() {}
    },
    protocols() {
      // if (!this.$store.getters.protocols.length && !this.$store.getters.protocolsLoaded) {
      //    this.$store.dispatch("app/loadProtocols");
      // }
      return this.$store.getters.protocols;
    },
    isNew() {
      return this.item.isNew ? true : false;
    },
    title() {
      return this.isNew ? "New Protocol Site" : "Edit Protocol Site";
    }
  },
  methods: {
    checkExists() {
      this.errors = false;
      if (this.item.protocol_id && this.item.site_id) {
        getDetail(this.item.protocol_id, this.item.site_id).then(data => {
          if (data.code) {
            this.$store.dispatch("app/openSnackbar", {
              message: "This site is already associated with this protocol!",
              color: "error"
            });
            this.errors = true;
          }
        });
      }
    },
    selectedSite(v) {
      this.sites.forEach( el => {
        if (el.id == this.item.site_id) {
          this.item.code = el.code;
        }
      })
    },
    close() {
      this.$store.dispatch("app/closeProtocolSiteDialog");
    },
    checkSave() {
      return !this.isNew || !this.errors
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }

      upsert(this.item)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: "Protocol Site updated correctly",
            color: "success"
          });
          const newItem = JSON.parse(JSON.stringify(data.data));
          this.$store.commit("app/protocolSiteItem", newItem);
          this.$root.$emit('updateProtocolSites', newItem);
        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the ProtocolSite update. " +
              e.response.data.message,
            color: "error"
          });
        });
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
